<template>
  <div class="multiselect" @click.stop="$refs.multiselect.focus()" :class="{ invalid: invalidInput }">
    <div class="wrapper">
      <div
        class="selected"
        v-for="(selected, index) in selected"
        :key="index"
        @click="$refs.multiselect.focus()"
        :class="{ 'no-value': selected.danger }"
      >
        <span>{{ selected.label || selected.value }}</span>
        <span v-show="selected.danger" :tooltip="$t('multiselect.no-value')"
          ><i class="fa-light fa-exclamation-circle"></i
        ></span>
        <span @click.stop="handleRemoveByName(selected)" class="remove-btn">
          <i class="fa-light fa-times"></i>
        </span>
      </div>

      <input
        ref="multiselect"
        class="multiselect-input select"
        type="text"
        :required="required"
        :class="{ 'not-empty': selected.length > 0 }"
        :placeholder="selected.length > 0 ? '' : placeholder"
        v-model="listFilter"
        @keydown.delete="removeLatest()"
        @focus="calculateMaxHeight()"
        @keyup.up="onUp()"
        @keyup.down="onDown()"
        @keyup.stop.enter="handleSelect(selectedIndex)"
        @keyup.esc="blurOption($event)"
      />
      <label class="top-label">{{ label }}</label>
    </div>

    <div class="list-wrapper">
      <div class="list custom-scrollbar custom-scrollbar-light" ref="list" :style="listStyles">
        <label
          v-for="(option, index) in filteredOptions"
          :key="index"
          :class="{
            selection: index === selectedIndex,
            'is-selected': selected.map((s) => s.value).includes(option.value)
          }"
          :ref="'list-item-' + index"
          @keyup.stop.enter="handleSelect(index)"
          @click.stop="handleSelect(index)"
          @keyup.esc="blurOption($event)"
          @keyup.up="onUp()"
          @keyup.down="onDown()"
          @focus="selectedIndex = index"
          @mouseenter="selectedIndex = index"
        >
          <span>{{ option.label }}</span>
          <!-- <input type="checkbox" :value="option" v-model="selected" @change="$refs.multiselect.focus()" /> -->
        </label>
        <span v-if="filteredOptions.length == 0" class="text-small text-muted">{{ $t("no-result") }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: [String, Number],
    source: [String, Object],
    value: [Number, String],
    options: Array,
    label: String,
    placeholder: String,
    required: Boolean,
    invalidInput: Boolean,
    fixedMaxHeight: Number
  },
  data() {
    return {
      selected: [],
      listFilter: "",
      selectedIndex: 0,
      yPos: null,
      windowHeight: null,
      listMaxHeight: null
    };
  },

  computed: {
    listStyles() {
      return {
        maxHeight: this.fixedMaxHeight ? this.fixedMaxHeight + "px" : this.listMaxHeight + "px",
        minHeight: this.fixedMaxHeight ? this.fixedMaxHeight + "px" : "100px"
      };
    },
    filteredOptions() {
      return this.options.filter((o) => o.label.toLowerCase().includes(this.listFilter.toLowerCase()));
    },

    result() {
      return this.selected.map((s) => s.value).join("||");
    }
  },

  methods: {
    onUp() {
      this.$refs.multiselect.focus();
      if (this.selectedIndex > 0) {
        this.selectedIndex = this.selectedIndex - 1;
      } else {
        this.selectedIndex = this.filteredOptions.length - 1;
      }
      this.$refs["list-item-" + this.selectedIndex][0].scrollIntoView();
    },

    onDown() {
      this.$refs.multiselect.focus();
      if (this.selectedIndex == this.filteredOptions.length - 1) {
        this.selectedIndex = 0;
      } else {
        this.selectedIndex = this.selectedIndex + 1;
      }

      if (
        this.$refs.list.getBoundingClientRect().bottom <
          this.$refs["list-item-" + this.selectedIndex][0].getBoundingClientRect().bottom ||
        this.selectedIndex == 0
      ) {
        this.$refs["list-item-" + this.selectedIndex][0].scrollIntoView(false);
      }
    },

    handleSelect(index) {
      if (index == (undefined || null) || this.filteredOptions.length <= 0) return;

      if (this.selected.some((s) => s.value == this.filteredOptions[index].value)) {
        this.selected.splice(this.selected.findIndex((s) => s.value == this.filteredOptions[index].value), 1);
      } else this.selected.push(this.filteredOptions[index]);
      this.$refs.multiselect.focus();
    },

    handleRemoveByName(name) {
      this.selected.splice(this.selected.findIndex((s) => s == name), 1);
    },

    blurOption(e) {
      e.target.blur();
    },

    removeLatest() {
      if (this.listFilter.length == 0) {
        this.selected.pop(1);
      }
    },

    calculateMaxHeight() {
      this.yPos = this.$refs.list.getBoundingClientRect().top;
      this.windowHeight = window.innerHeight;
      this.listMaxHeight = this.windowHeight - this.yPos - 20;
    }
  },
  mounted() {
    if (this.value) {
      const values = this.value.split("||");
      values.forEach((val) => {
        const match = this.options.find((o) => o.value == val);
        if (match) {
          this.selected.push(match);
        } else {
          this.selected.push({ value: val, danger: true });
        }
      });
    }
  },

  watch: {
    result: {
      handler: function() {
        this.$emit("value-change", this.result);
      }
    },
    listFilter: {
      handler: function() {
        this.selectedIndex = 0;
      }
    }
  }
};
</script>

<style lang="less">
.multiselect {
  position: relative;
  .top-label {
    color: var(--text-grey-primary);
    font-weight: 800;
    cursor: pointer;
    padding: 0 2px 0 0;
    transform: translate(0px, 12px) scale(0.8);
    transform-origin: 0 0;
    margin-bottom: 8px;
  }
  .wrapper {
    margin-top: 4px;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #ccc;
    position: relative;
    flex-wrap: wrap;
    gap: 4px;
  }
  .multiselect-input {
    min-width: 10px;
    outline: none;
    border: none;
    flex-grow: 1;
    flex-basis: 40px;
    &::placeholder {
      opacity: 1;
      color: #8f979c;
      font-weight: 500;
      max-width: 95%;
    }
  }
  .selected {
    display: flex;
    align-items: center;
    flex-direction: row;
    background: var(--background-white);
    color: var(--orange-web);
    border-radius: 4px;
    border: 1px solid var(--orange-web);
    max-width: 100%;
    span {
      padding: 0 4px;
      &:first-of-type {
        padding-right: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      svg {
        font-size: 10px;
        padding-bottom: 1px;
      }
    }
    .remove-btn {
      border-left: 1px solid var(--orange-web);
      &:hover {
        cursor: pointer;
        border-radius: 0 3px 3px 0;
        background-color: var(--alabaster);
      }
    }

    &.no-value {
      border-color: var(--danger-red);
      color: var(--danger-red);
      .remove-btn {
        border-color: var(--danger-red);
      }
    }
  }
  .list-wrapper {
    border-radius: var(--standard-border-radius);
    padding: 5px;
    opacity: 0;
    position: absolute;
    width: 100%;
    z-index: 199;
    pointer-events: none;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    background: #fff;
  }
  .list {
    padding-top: 4px;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    pointer-events: none;

    input {
      display: none;
    }
  }

  &:focus-within {
    .list-wrapper {
      transition: 0.2s;
      opacity: 1;
      pointer-events: auto;
    }
  }
  .list-wrapper:hover {
    transition: 0.2s;
    opacity: 1;
    pointer-events: auto;
    .list {
      pointer-events: auto;
    }
  }

  .list-wrapper label {
    margin-bottom: 2px;
    padding-left: 4px;
  }

  .selection {
    background-color: var(--alabaster);
  }

  .is-selected {
    color: var(--orange-web);
  }
  .top-label {
    color: #8f979c;
    font-weight: 500;
    position: absolute;
    top: 0;
  }

  .top-label,
  .multiselect-input {
    transition: all 0.2s;
    touch-action: manipulation;
  }
  .multiselect-input:placeholder-shown + .top-label {
    cursor: text;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    // transform: translate(-10px, 40px) scale(1);
    transform: translate(0px, 12px);
  }
  .multiselect-input::-webkit-input-placeholder {
    opacity: 0;
    transition: inherit;
  }
  .multiselect-input:focus::-webkit-input-placeholder {
    opacity: 1;
  }
  .multiselect-input:not(:placeholder-shown) + .top-label,
  .multiselect-input:focus + .top-label,
  .multiselect-input:-webkit-autofill + .top-label,
  .multiselect-input.not-empty + .top-label {
    transform: translate(0px, -18px) scale(0.8);
    transform-origin: 0 0;
    width: max-content;
    padding: 0 2px 0 0;
    color: inherit;
    color: #8f979c;
    font-weight: bold;
    cursor: pointer;
  }
  .select {
    background-image: url("../../src/assets/svg/chevronDown.svg");
    background-repeat: no-repeat;
    background-position: 99% 50%;
    background-size: 8px;
  }

  //   .wrapper(.multiselect-input:focus) {
  //     border-bottom: 1px solid #666;
  //   }

  &.invalid {
    .multiselect-input:focus + .top-label {
      color: var(--danger-red) !important;
    }
    .wrapper {
      border-bottom: 1px solid var(--danger-red);
    }
  }
}
</style>
